import React, { Component } from "react";
import "./header/Header.css"; 
import "../scss/general.css"
import Moment from "moment";
import Mymodal from './modalleave';
import config from '../config';
import logo from "./images/loading.gif";
import Cookies from "universal-cookie";
import modallogo from "./images/loader.gif";
import Modal from "react-bootstrap/Modal";
import BusyModal from "./modalwait";
import 'react-day-picker/lib/style.css';
const  axios = require("axios");
const cookies = new Cookies();
const items = [
  'One',
  'Two',
  'Three',
];
const columns = [
  {
    field: "name",
    header: "Name",
    width: "200px",
  },
  {
    field: "designation",
    header: "Designation",
    width: "200px",
  },
];

const initialState={
  input:{},
  formid:"",
  input2:{},
  myitems:[],
  arrayleaverevoke:[],
  leavedata:{},
  tLeave:0,
  isLoaded: false,
  isData: false,
  leaveDays:0,
  edsubmit:true,
  options:false,
  AAnnual:0,ASick:0,ACasual:0,ALWP:0,ACMP:0,
  selectedDays:[],
  error:"",
  disDIV:"none",
  errorcss:"labelerror",
  textreason:"",
  authority:[],
  toname:"",
  toemail:"",
  ErrMsg2:"",
  St:0,
  isOpen:false,
  authorityD:[{"emp_id":"1","name":"CE","designation":"Chief Executive",email:"Khalil.Sattar@KandNs.com"},{"emp_id":"2","name":"ED","designation":"Executive Director",email:"Adil.Sattar@KandNs.com"}],

  ErrMsg:"" 

}
class leaverevoke extends Component{
  static defaultProps = {
    numberOfMonths: 2,
  };
  constructor(props){
        super(props);
        this.state=initialState;
        this.handlechangefrom = this.handlechangefrom.bind(this);
        this.handlechangeto = this.handlechangeto.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleoptionclick = this.handleoptionclick.bind(this);
        this.handleClear = this.handleClear.bind(this);
        this.handleTextChange = this.handleTextChange.bind(this);
        this.optionG = this.optionG.bind(this);
        this.optionD = this.optionD.bind(this);
        this.ErrHandler = this.ErrHandler.bind(this);
        this.handleCheckbox = this.handleCheckbox.bind(this);
    }
    ErrHandler(){
      this.setState({...initialState});
      this.componentDidMount();
    } 

    handlechangefrom(date)
    {
      this.setState({fdate:Moment(date).format("DD/MM/YYYY")});

    }
    handlechangeto(date)
    {
      this.setState({tdate:Moment(date).format("DD/MM/YYYY")});
      this.setState({toDate:date});
    }
    timeChangeFrom=(event)=>{
      this.setState({fromTime:Number(event.target.value)});

    }    
    timeChangeTo=(event)=>{
      this.setState({toTime:Number(event.target.value)});
    }    
    cur=(num)=> {
      let cnum=parseInt(num,0);
      if(num > 0)
        return num.toFixed(1).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
      else
        return "-"
    }
    optionG(e){
      this.setState({toname:this.state.authority[e.target.value].name,toemail:this.state.authority[e.target.value].email,edsubmit:false});
    }
    optionD(e){
      this.setState({toname:this.state.authorityD[e.target.value].name,toemail:this.state.authorityD[e.target.value].email,edsubmit:false});
    }
    handleTextChange(e){
      this.setState({textreason:e.target.value});
    }
    componentDidMount()
    {
      if(typeof this.props.location.data !== "undefined")
      { 
        let input2=this.props.location.data;        
        this.setState({ErrMsg:<img src={logo} alt=''/>,input2});
        document.body.style.cursor="wait";
        let input=this.state.input;
        input["ID"]=cookies.get("LoginID");
        this.setState({input, isLoaded: false});
        axios.all([
            axios({
              method: 'post',
              url: cookies.get("phpclass")+'/index.php/user/leave/'+input["ID"],
              headers: {'Content-Type': 'multipart/form-data'}
              }),
              axios({
                method: 'post',
                url: cookies.get("phpclass")+'/index.php/user/leavedates/'+input2["formid"],
                headers: {'Content-Type': 'multipart/form-data'}
                })
            ])
            .then(axios.spread((response,res2) => {
                document.body.style.cursor="default";
                let leavedata=this.state.leavedata;
                let selectedDays=this.state.selectedDays;
                selectedDays=res2.data;
                leavedata["TAnnual"]=Number(response.data[0].BF_ANNUAL)+Number(response.data[0].ANNUAL)-Number(response.data[0].E_ANNUAL)-Number(response.data[0].L_ANNUAL);
                leavedata["TCasual"]=Number(response.data[0].CASUAL)-Number(response.data[0].E_CASUAL)-Number(response.data[0].L_CASUAL);
                leavedata["TSick"]=Number(response.data[0].SICK)-Number(response.data[0].E_SICK)-Number(response.data[0].L_SICK);
                leavedata["TLWP"] = 0;
                leavedata["TCMP"] = 0;
                this.setState({leavedata,selectedDays,isLoaded: true,ErrMsg:"",ErrMsg2:"",formid:input2["formid"] });
            }))
            .catch((response)=> {
                document.body.style.cursor="default";          
                this.setState({ErrMsg2:<Mymodal handler = {this.handleClear} Type="1" Title={config.gvr.ErrMsgs.TitleNotFound} Body={config.gvr.ErrMsgs.MsgNotFound}/>});
            });      
           /* Get Leave Authority*/
          axios({
            method: 'post',
            url: cookies.get("phpclass")+'/index.php/user/LeaveAuthority/'+this.state.input["ID"],
            headers: {'Content-Type': 'multipart/form-data'}
            })
            .then((response)=> {
                this.setState({authority:response.data,isLoaded:true});
                console.log(this.state.authority);
            })
            .catch((response)=> {
               document.body.style.cursor="default";
               this.setState({ErrMsg2:<Mymodal handler = {this.handleClear} Type="1" Title={config.gvr.ErrMsgs.TitleNotFound} Body={config.gvr.ErrMsgs.MsgNotFound}/>,isLoaded:false});
            });      
      }
      else
      {
        this.props.history.push({pathname: '/leaveapplist'});

      }    
    }    
    handleoptionclick=(e)=>{

      let evalue=e.target.value;
      this.setState({AAnnual:0,ASick:0,ACasual:0,ALWP:0,ACMP:0,edsubmit:true,leaveDays:0,selectedDays:[],from:undefined,to:undefined});
      if(evalue === "A")
        this.setState({optionValue:evalue, div1:"none",div2:"block",leavetype:"Annual"});
      if(evalue === "S")
        this.setState({optionValue:evalue,div1:"none",div2:"block",leavetype:"Sick"});
      if(evalue === "C")
        this.setState({optionValue:evalue,div1:"block",div2:"none",leavetype:"Casual"});
      if(evalue === "CP")
        this.setState({optionValue:evalue,div1:"block",div2:"none",leavetype:"Compensatory"});
//        this.handleProceed();
    }

  handleClear(){
    this.setState({ErrMsg2:""});
    if(this.state.St === 1)
    {
      this.setState({...initialState});
      this.componentDidMount();
    }
  }

  handleCheckbox(e, getday)
  {
    let newArray = this.state.myitems.slice();
    if(e.target.checked)
    {
      newArray.push([e.target.value,getday]);      
      this.setState({AAnnual:this.state.AAnnual+getday,ACasual:0,ASick:0,ALWP:0,disDIV:"",myitems:newArray,tLeave:+getday});        
    }
    else 
    {
      let array2 = this.state.myitems;
      let indexitem=array2.indexOf(e.target.value);
      array2.splice(indexitem,1);
      
//      alert(array2.length);
      if(array2.length == 0)
          this.setState({AAnnual:this.state.AAnnual-getday,ACasual:0,ASick:0,ALWP:0,disDIV:"none",myitems:array2,tLeave:-getday});        
      else
          this.setState({AAnnual:this.state.AAnnual-getday,ACasual:0,ASick:0,ALWP:0,disDIV:"",myitems:array2,tLeave:-getday});        

    }
  }

  handleSubmit(){
    let arrayleaverevoke = this.state.arrayleaverevoke;
    let leavearray=this.state.myitems;
    leavearray.sort((a,b) => (a > b) ? 1 : -1)
    this.setState({ErrMsg2:<BusyModal/>});
    let halffull=0;
    for(var i=0; i < leavearray.length ; i++){
      halffull+=Number(leavearray[i][1]);
      arrayleaverevoke.push({id:this.state.formid,leavedate:leavearray[i][0],leavetime:leavearray[i][1],tday:halffull,toemail:this.state.toemail,toname:this.state.toname,reason:this.state.textreason});
    }
    this.setState({arrayleaverevoke});
    document.body.style.cursor="wait";
//    axios.all([
      axios({
       method: 'post',
       url: cookies.get("phpclass")+'/index.php/user/RevokePartial/',
       data: this.state.arrayleaverevoke,
       headers: {'Content-Type': 'multipart/form-data'}
      })
      .then((res1)=> {
         document.body.style.cursor="default";
         if(res1.data === "2")
          {
            this.setState({isOpen:false,St:1,ErrMsg2:<Mymodal handler = {this.handleClear} Type="0" Title="Success" Body="Your request for leave approval sent successfully."/>});
          }         
          else 
          {   
            this.setState({isOpen:false,St:0,ErrMsg2:<Mymodal handler = {this.handleClear} Type="1" Title="Failed" Body="There might be a connection issue. Please try again."/>});
          }
      })
     .catch((response)=> {
        document.body.style.cursor="default";
        this.setState({isOpen:false,St:0,ErrMsg2:<Mymodal handler = {this.handleClear} Type="1" Title="Failed" Body="Transaction is not possible this time, please try after few minutes"/>});
      });
  }
  


 render(){
  let items=this.state.authority;
  let itemsD=this.state.authorityD;
  let isLoaded =this.state.isLoaded;
  let halffull="";
  if(this.state.ErrMsg.length > 5)
    return(<div>{this.state.ErrMsg}</div>)      
  if (!isLoaded) 
  {
      return(
      <div className={config.changeDivClass}>
        <div className="center">
           {this.state.ErrMsg}
        </div>
      </div>
      );    
  } 
  else 
  {
  return (
    <div className="container1">
          {this.state.ErrMsg}

      <br></br>                             
      <div width="100%" align="center" >
            <br></br>
        <div className="inner-profile">
          <span className="box-title">Revoke leaves</span>
          <br></br>  
          <div style={{marginTop:"15px",marginBotton:"15px",width:"100%"}}>
            <table style={{width:"100%"}}>
              <thead></thead>
              <tbody>
              <tr>
                <td style={{width:"20%",textAlign :"left", padding:"1px",border: "1px solid rgb(161, 159, 159)" }}>
                  Application Id#
                </td>
                <td style={{width:"20%",textAlign :"left", padding:"1px",border: "1px solid rgb(161, 159, 159)"}}>
                  {this.state.input2["formid"]}
                </td>
                <td style={{width:"20%",textAlign :"left", padding:"1px",border: "1px solid rgb(161, 159, 159)"}}>
                  Application Date:
                </td>
                <td style={{width:"20%",textAlign :"left", padding:"1px",border: "1px solid rgb(161, 159, 159)"}}>
                  {Moment(this.state.input2["applydate"]).format("DD/MM/YYYY")}
                </td>
              </tr>
              <tr>
                <td style={{width:"20%",textAlign :"left", padding:"1px",border: "1px solid rgb(161, 159, 159)" }}>
                  Leave period
                </td>
                <td style={{width:"20%",textAlign :"left", padding:"1px",border: "1px solid rgb(161, 159, 159)"}}>
                  {Moment(this.state.input2["from"]).format("DD/MM/YYYY")} to {Moment(this.state.input2["to"]).format("DD/MM/YYYY")}
                </td>
                <td style={{width:"20%",textAlign :"left", padding:"1px",border: "1px solid rgb(161, 159, 159)"}}>
                  Total days:
                </td>
                <td style={{width:"20%",textAlign :"left", padding:"1px",border: "1px solid rgb(161, 159, 159)"}}>
                  {Number(this.state.input2["days"])} day/s ({this.state.input2["type"]})
                </td>
              </tr>
              <tr>
                <td style={{width:"20%",height:"30px",textAlign :"left", padding:"1px",backgroundColor:"gray",color:"white",border: "1px solid rgb(161, 159, 159)"}} colSpan={4}>Leaves application detail</td>
              </tr>
              <tr key={i}>
                <td style={{width:"20%",height:"30px",textAlign :"left", padding:"1px",backgroundColor:"lightgray",color:"white",border: "1px solid rgb(161, 159, 159)"}} colSpan={4}>
              {this.state.selectedDays.map((result,i)=>{
                if(result.ifhalf==0.5) halffull="half day"; else  halffull="Full day";
                if(result.diff <= 0 || result.isrevoke){
                  return(
                    <div key={i} style={{width:"25%",float:"left",textAlign:"left",padding:5,backgroundColor:"lightgray",color:"black"}} disabled><input type="checkbox" value={result.leavedate} disabled checked={result.isrevoke} />{Moment(result.leavedate).format("D MMMM yyyy")}({halffull})</div>
                  );
                }
                else
                {
                  return(
                    <div key={i} style={{width:"25%",float:"left",textAlign:"left",padding:5,backgroundColor:"lightgray",color:"black"}}><input type="checkbox" value={result.leavedate} onChange={e => this.handleCheckbox(e,Number(result.ifhalf))}/>{Moment(result.leavedate).format("D MMMM yyyy")}({halffull})</div>
                  );
                }
              })}
              </td>
              </tr>
              </tbody>
            </table>
          </div>
          <br/>
          <table style={{width:"100%"}}  >
            <thead >
              <tr >
                  <th className="thm" scope="col"></th>
                  <th className="thm" scope="col">ANNUAL</th>
                  <th className="thm" scope="col">CASUAL</th>
                  <th className="thm" scope="col">SICK</th>
                  <th className="thm" scope="col">LWP</th>
                  <th className="thm" scope="col">CMP</th>
                  <th className="thm" scope="col">TOTAL</th>
              </tr>
            </thead>
            <tbody >
            <tr>
                <td className="tddesc" >Balance B/F</td>
                <td className="tdamb" >{this.cur(this.state.leavedata["TAnnual"])}</td>
                <td className="tdamb" >{this.cur(this.state.leavedata["TCasual"])}</td>
                <td className="tdamb" >{this.cur(this.state.leavedata["TSick"])}</td>
                <td className="tdamb" >{this.cur(0)}</td>
                <td className="tdamb" >{this.cur(0)}</td>
                <td className="tdamb" >{this.cur(Number(this.state.leavedata["TSick"])+Number(this.state.leavedata["TCasual"])+Number(this.state.leavedata["TAnnual"]))}</td>
            </tr>
            <tr >
                <td className="tddesc">Revoke for</td>
                <td className="tdamb">{this.cur(this.state.AAnnual)}</td>
                <td className="tdamb">{this.cur(this.state.ACasual)}</td>
                <td className="tdamb">{this.cur(this.state.ASick)}</td>
                <td className="tdamb">{this.cur(this.state.ALWP)}</td>
                <td className="tdamb">{this.cur(this.state.ACMP)}</td>
                <td className="tdamb">{this.cur(this.state.ASick+this.state.ACasual+this.state.AAnnual+this.state.ALWP+this.state.ACMP)}</td>
            </tr>
            <tr>
                <td className="tdhead" ><b>Balance</b></td>
                <td className="tdambhead" >{this.cur(this.state.leavedata["TAnnual"]+this.state.AAnnual)}</td>
                <td className="tdambhead" >{this.cur(this.state.leavedata["TCasual"]+this.state.ACasual)}</td>
                <td className="tdambhead" >{this.cur(this.state.leavedata["TSick"]+this.state.ASick)}</td>
                <td className="tdambhead" >{this.cur(0)}</td>
                <td className="tdambhead" >{this.cur(0)}</td>
                <td className="tdambhead" >{this.cur(Number(this.state.leavedata["TSick"])+Number(this.state.leavedata["TCasual"])+Number(this.state.leavedata["TAnnual"]+(this.state.AAnnual+this.state.ACasual+this.state.ASick)))}</td>
            </tr>
            <tr>
              <td colSpan="7">
                <label htmlFor="story"><b>Reason or Purpose:</b></label>
                <div width="100%">
                  <textarea name="textValue" title="Reason or Purpose"  onChange={this.handleTextChange} style={{width:"100%", height:"100px"}} />
                </div>
              </td>
            </tr>
            <tr>
              <td colSpan="4"><b>Approval authority</b></td>
              <td colSpan="3"><b>for direct reporting</b></td>
            </tr>
            <tr>
              <td colSpan="4" >
              <div style={{width:"100%",height:"150px",overflow:"auto",border:"gray solid 1px", float:"left",pointerEvents: this.state.disDIV}}>
                  <table style={{width:"100%",marginLeft:"5p"}} >
                    <thead></thead>
                    <tbody>
                      {items.map((result ,i) => {
                      return (
                        <tr className="trc" key={i}>
                        <td style={{width:"56%",paddingLeft:"5px"}}><input  id={result.name}  type="radio" value={i} name="inputopt" onChange={this.optionG}/><label className="lebel2" htmlFor={result.name}>{result.name}</label></td>
                        <td style={{width:"44%"}}>{result.designation}</td>


{/*}                          <td style={{width:"6%"}}><input style={{marginLeft:"5px"}} type="radio" value={i} name="inputopt" onChange={this.optionG}/></td>
                          <td style={{width:"50%"}}>{result.name}</td>
                      <td style={{width:"44%"}}>{result.designation}</td>*/}
                      </tr>
                      )})}
                    </tbody>
                  </table>
              </div>
              </td>
              <td colSpan="3">
                <div style={{width:"100%",height:"150px",overflow:"auto",border:"gray solid 1px", float:"righ",pointerEvents:this.state.disDIV}} >
                  <table style={{width:"100%",marginLeft:"5p"}}>
                    <thead></thead>
                    <tbody>
                      {itemsD.map((resultd ,i) => {
                      return (
                        <tr className="trc" key={i} >
                            <td style={{width:"10%"}}><input style={{marginLeft:"5px"}} type="radio" value={i} name="inputopt"  onChange={this.optionD}/></td>
                            <td style={{width:"92%"}}>{resultd.designation}</td>


{/*}                          <td style={{width:"10%"}}><input style={{marginLeft:"5px"}} type="radio" value={i} name="inputopt" onChange={this.optionD}/></td>
                          <td style={{width:"92%"}}>{resultd.designation}</td>*/}
                        </tr>
                        )})}
                    </tbody>                  
                  </table>
                </div>
              </td>
            </tr>
            </tbody>

          </table>
          <br/>
          <span  style={{align:"center",paddingTop:"15px", height:"100px"}} >
            <button onClick={this.handleSubmit} className="btn btn-secondary active" disabled={this.state.edsubmit}>Submit</button>
            <div style={{width:"5px", height:"auto", display:"inline-block"}}/>
              <button onClick={this.handleClear} className="btn btn-secondary active">Clear</button>
          </span>
      </div>
    </div>
    <div className="center">
           {this.state.ErrMsg2}
    </div>
    <Modal show={this.state.isOpen} animation="false" centered backdrop="static" size="sm">
    <Modal.Body><img src={modallogo} width="30px" height="30px"/><span style={{PaddingLeft:"15px"}}>Please wait...</span></Modal.Body>
    </Modal>


  </div>
  );  
}  
 } 
}
export default leaverevoke;